import { easyPost } from './utils';

// 获取用户个人信息
// eslint-disable-next-line
export const getUserInfo = easyPost('user.account.getInfo');

// 个人信息收集清单
export const getUserInfoCollection = easyPost('bff.component.data');
